import { Component, OnInit } from '@angular/core';
import { LoginService } from './services/login.service';
import { Globals } from './objects/Globals';
import { TokenManager } from './Globals';
import { Router } from '@angular/router';
import { ToasterService, ToasterConfig, Toast, BodyOutputType } from 'angular2-toaster';
import { ThemeSettingService } from './services/theme-setting.service';
import { ngxLoadingAnimationTypes } from 'ngx-loading';
import { HeaderService } from './services/header.service';
import { Observable, Subscription, fromEvent, of, merge } from 'rxjs';
import { mapTo } from 'rxjs/operators';
import {enableProdMode} from '@angular/core';
import { AppSession } from './objects/Session';
import { ConfirmationService } from './services/confirmation.service';
import { BsModalService } from 'ngx-bootstrap';
import { MainLoadingService } from './services/main-loading.service';
import { ToasterMessageService } from './services/toaster-message.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Device, DeviceType } from './objects/DeviceInfoObject';
import { EnvService } from './env.service';
import { Title } from '@angular/platform-browser';
import { SessionTimerService } from './services/session-timer.service';
import { trigger, state, style, transition, animate, animateChild, query, group } from '@angular/animations';
import { SidePopupService } from './services/side-popup.service';

enableProdMode();

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [trigger('slider', [
    state('closed', style({
      width: '0px',
      display: 'none'
    })),
    state('open', style({
      width: '525px',
      display: 'block'
    })),
    transition('open => closed', [
      group([
        animate('100ms'),
        query('@openClose', [
          animateChild()
        ], {optional: true})  
      ])
    ]),
    transition('closed => open', [
      group([
        animate('100ms'),
        query('@openClose', [
          animateChild(),
        ], {optional: true})  
      ])
    ]),
  ])]
})
export class AppComponent implements OnInit {

  private toasterService: ToasterService;
  isSessionAlive: boolean;
  errorCount:number = 0;
  currentMessage:string;
  loaderConfig:any;
  isBusy:boolean = false;
  sub:Subscription;
  online$: Observable<boolean>;
  online:boolean;
  toast:Toast;
  device: Device;
  deviceInfo = null;
  isDefault: boolean;
  hasBackground: boolean;
  primaryColour: string;
  secColor: string;
  accentColor: string;
  baseColor: string;
  iconColor: string;
  isProgressing: boolean;
  tabsArray: any = [];
  showBackdrop: boolean = false;
  detailId: string;
  slideIn: boolean = false;

  constructor(private loginService:LoginService,
    private globals: Globals, 
    private tokenManager: TokenManager, 
    private router:Router, toasterService: ToasterService, 
    private themeSettingService: ThemeSettingService, 
    private headerService:HeaderService, 
    private confirmationService:ConfirmationService,
    private modalService: BsModalService,
    private mainLoadingService:MainLoadingService,
    private toasterMessageService:ToasterMessageService,
    private deviceService: DeviceDetectorService,
    private env: EnvService,
    private title:Title,
    private sessionTimerService: SessionTimerService,
    private sidePopupService: SidePopupService) {
      this.getColor();
      this.checkDevice();

      this.sidePopupService.currentPopupChanged$.subscribe(result => {
        if (result){
          this.detailId = result;
          this.slideIn = true;
        }
        else{
          this.slideIn = false;
        }

      });

      this.toasterService = toasterService;
      this.online$ = merge(
        of(navigator.onLine),
        fromEvent(window, 'online').pipe(mapTo(true)),
        fromEvent(window, 'offline').pipe(mapTo(false))
      )

      this.loginService.online$.subscribe(online => {
        this.online = online;
        if (this.online && this.sub){
          if (this.sub.closed){
            let timer = Observable.timer(1000,10000);
            this.sub = timer.subscribe(t => this.checkSession());
            this.toasterService.clear(this.toast.toastId, this.toast.toastContainerId);
            document.querySelectorAll(".backdrop").item(0).classList.remove("main-backdrop");
          }
        }
      });

      router.events.subscribe((event)=>{ //fires on every URL change
        title.setTitle(this.env.portalTab);
        if (router.url == "/login" || router.url == "/" || router.url == "/supplier-registration" || router.url.indexOf("/onetimeaction") > -1 || router.url.indexOf("/resetpassword")> -1){
          this.isDefault = true;
        }
        else{
          this.isDefault = false;
        }

        if (router.url == "/faq" || router.url == "/contact-us" || router.url == "/vendor-applications"){
          this.hasBackground = true;
        }
        else{
          this.hasBackground = false;
        }
      });

      headerService.isSessionAliveChanged$.subscribe(result => {
        this.isSessionAlive = result;
      });

      this.mainLoadingService.mainLoadingChanged$.subscribe(value => {
        if (value){
          this.isBusy = true;
        }
        else {
          this.isBusy = false;
        }
      });

      this.mainLoadingService.progressBarChanged$.subscribe(value => {
        this.isProgressing = value;
      })
  }

  getColor(){
    this.primaryColour = this.env.primaryColor;
    this.secColor = this.env.secondaryColor;
    this.accentColor = this.env.accentColor;
    this.baseColor = this.env.baseColor;
    this.iconColor = this.env.iconColor;
  }

  public config: ToasterConfig = 
  new ToasterConfig({
    animation: 'fade',
    timeout: 5000,
    tapToDismiss : false,
    mouseoverTimerStop: true
  });

  ngOnInit(){
    let timer = Observable.timer(1000,10000);
    this.sub = timer.subscribe(t => this.checkSession());

    const colors = new Map([
      ['primary', this.primaryColour],
      ['secondary', this.secColor],
      ['accent', this.accentColor],
      ['base', this.baseColor],
      ['icon', this.iconColor]
    ])
    
    Array.from(colors.entries()).forEach(([name, value]) => {
      document.body.style.setProperty(`--${name}`, value);
    });

    this.themeSettingService.setTheme({
      animationType: ngxLoadingAnimationTypes.threeBounce, 
      backdropBackgroundColour: 'rgba(255, 255, 255,0.2)',
      backdropBorderRadius: '10px',
      primaryColour: this.primaryColour, 
      secondaryColour: this.primaryColour,
      tertiaryColour: this.primaryColour,
      accentColour: this.accentColor});

      this.headerService.displayMenu(true);
      this.loaderConfig = this.themeSettingService.getTheme();
  }

  changeColour() {
    var theme = this.randomTheme();
    this.primaryColour = theme.primary;
    this.secColor= theme.secondary;
    this.accentColor = theme.accent;

    document.body .style.setProperty(`--primary`, this.primaryColour);
    document.body.style.setProperty(`--secondary`, this.secColor);
    document.body.style.setProperty(`--accent`, this.accentColor);
    document.body.style.setProperty(`--base`, this.baseColor);
  }

  randomTheme(): Theme {
    const primary = this.randomHex();
    const secondary = this.randomHex();
    const accent = this.randomHex();
    return { primary,secondary, accent };
  }

  private randomHex() {
    return '#' + Math.floor(Math.random() * 16777215).toString(16);
  }

  checkSession(){
    if (this.online){
      var sessionCookie = JSON.parse(this.tokenManager.retrieve("BRNSessionKey"));
      if(sessionCookie && this.errorCount < 5){
        this.loginService.getSession(sessionCookie).subscribe(result => {
          if(result){
            var checkSessionObject = JSON.parse(result);
            if(checkSessionObject.StatusCode != 200)
            {
              if (this.currentMessage == checkSessionObject.StatusMessage){
                this.errorCount++;
              }
              else {
                this.errorCount = 0;
              }

              if (this.currentMessage != checkSessionObject.StatusMessage){
                this.currentMessage = checkSessionObject.StatusMessage;
                if (this.isSessionAlive){  // temporary state manager
                  this.popToast("Warning", checkSessionObject.StatusMessage, "warning", 0);
                  this.headerService.setSessionAlive(false);
                }
              }
              this.tokenManager.store("BRNSessionKey", null);
              this.loginService.setSession(null);

              this.sessionTimerService.stopSessionTimer();

              setTimeout(() => {
                this.isBusy = false;
                this.globals.Session = null;
                this.router.navigate(['/login']);
              },5000)

              // hides all the modals
              this.hidesAllModals();
              
            }
            if(checkSessionObject.SessionObject)
            {
              var sessionObject:AppSession = checkSessionObject.SessionObject;
              this.loginService.setSession(sessionObject);
            }
          }
          else {
            this.sessionTimerService.stopSessionTimer();
            this.tokenManager.store("BRNSessionKey", null);
            this.popToast("Warning", "You have been logged out. Somebody has logged into your account from another device.", "warning", 0);
            this.loginService.setSession(null);
            
            setTimeout(() => {
              this.globals.Session = null;
              this.router.navigate(['/login']);
            },5000)

            // hides all the modals
            this.hidesAllModals()
          }
        },
        error => {
          if(error.status == 0){
            this.loginService.setSession(null);
          }
        });
      }else{
        if (this.router.url != '/supplier-registration'){
          this.loginService.setSession(null);
        }
      }
    }
    else {
      if (this.globals.Session){
        this.popToast("Connection is lost", "There seems to be a problem connecting to the server, please contact system administrator accordingly", "error", 0);
        document.querySelectorAll(".backdrop").item(0).classList.add("main-backdrop");
        this.loginService.setSession(null);
      }
      this.sub.unsubscribe();
    }
  }

  hidesAllModals(){
    if (this.confirmationService.bsModalRef){
      this.confirmationService.bsModalRef.hide();
    }
    for (let i = 1; i <= this.modalService.getModalsCount(); i++) {
      this.modalService.hide(i);
    }
    document.body.classList.remove('modal-open');

    this.sidePopupService.removePopup();
  }

  popToast(title: string, body: string, type: string, timeout:number) {
    this.toast = {
      type: type,
      title: title,
      body: body,
      showCloseButton: true,
      timeout: timeout,
      bodyOutputType: BodyOutputType.TrustedHtml,
      onHideCallback:(toast) => {
        // document.querySelectorAll(".backdrop").item(0).classList.remove("main-backdrop");
      }
    };
    //var toasterObj = this.toasterMessageService.getToaster()
    this.toasterService.pop(this.toast);
    
  }

  checkDevice(){
    var deviceType: DeviceType;
    this.deviceInfo = this.deviceService.getDeviceInfo();
    const isMobile = this.deviceService.isMobile(); // returns if the device is a mobile device (android / iPhone / windows-phone etc)
    const isTablet = this.deviceService.isTablet(); // returns if the device us a tablet (iPad etc)
    const isDesktopDevice = this.deviceService.isDesktop(); // returns if the app is running on a Desktop browser.

    if (isMobile) { 
      deviceType = DeviceType.MOBILE; 
    }
    else if (isTablet) { 
      deviceType = DeviceType.TABLET; 
    }
    else if (isDesktopDevice) { 
      deviceType = DeviceType.DESKTOP; 
    }

    this.device = {
      deviceInfo: this.deviceInfo,
      isMobile: isMobile,
      isTablet: isTablet,
      isDekstop: isDesktopDevice,
      deviceType: deviceType
    }

    this.loginService.setDeviceInfo(isMobile);

    // console.log(this.device);
  }

  activeTabs(isActive: string){
    if (isActive == 'active'){
      this.showBackdrop = true;
    }
    else{
      this.showBackdrop = false;
    }
  }

  hide(){
    this.slideIn = false;
    this.sidePopupService.removePopup();
  }
}

export interface Theme {
  primary: string;
  secondary: string;
  accent: string;
}